/*
 * Balisa d'errors de MundoParquet (vigilància, lot 1b).
 * Envia a l'app de MP, sense dades personals, quan a un client real:
 *  - li salta un error de JavaScript o una promesa no gestionada;
 *  - li falla l'afegir al carret (/cart/add o /cart/add.js respon error de servidor o de xarxa).
 * Els camins amb tokens (comptes, comandes, checkout) només s'envien com a categoria; URLs sense
 * paràmetres, correus i trossos llargs tapats. Mai envia res abans que la persona hagi interactuat (clic, tecla o toc reals), ni en
 * navegadors automatitzats, ni si la pestanya s'ha obert amb ?prova=1. Màxim 5 avisos per pàgina.
 * Interruptor sense desplegar: Personalitza el tema › Configuració del tema › Vigilancia.
 */
(() => {
  const script = document.currentScript;
  const endpoint = script && script.dataset.endpoint;
  if (!endpoint || !window.fetch || navigator.webdriver) return;

  try {
    if (/[?&]prova=1(?:&|$)/.test(location.search)) sessionStorage.setItem('mp_prova', '1');
    if (sessionStorage.getItem('mp_prova') === '1') return;
  } catch (_) {
    /* sessionStorage blocat: continuem */
  }

  let interacted = false;
  const onTrusted = (event) => {
    if (event.isTrusted) interacted = true;
  };
  for (const type of ['pointerdown', 'keydown', 'touchstart']) {
    addEventListener(type, onTrusted, { capture: true, passive: true });
  }

  const rawTemplate = (document.body && document.body.dataset.mpTemplate) || '';
  const template = /^[a-z0-9][a-z0-9_/-]{0,59}$/.test(rawTemplate) ? rawTemplate : undefined;
  // Shopify posa tokens secrets dins d'alguns camins (comptes, estat de comandes, checkout):
  // aquests camins s'envien només com a categoria; a la resta, qualsevol tros llarg es tapa.
  const SENSITIVE_PATH = /^\/(?:\d+\/)?(?:account|orders|checkouts|checkout|tools\/recurring|apps)\b/i;
  const scrub = (text) =>
    String(text)
      .replace(/https?:\/\/[^\s?#]+(?:[?#]\S*)?/g, (url) => url.split(/[?#]/)[0])
      .replace(/[\w.+-]+@[\w-]+\.[\w.-]+/g, '[email]')
      .replace(/[A-Za-z0-9_-]{24,}/g, ':token')
      .replace(/\b[a-f0-9]{16,}\b/gi, ':token');
  const safePath = () => {
    const path = location.pathname;
    if (SENSITIVE_PATH.test(path)) return `/${path.split('/').filter(Boolean)[0]}/*`;
    return scrub(path).slice(0, 500);
  };
  const seen = new Set();
  let sent = 0;
  const nativeFetch = window.fetch.bind(window);

  const send = (kind, message) => {
    if (!interacted || sent >= 5) return;
    const text = scrub(message || kind).slice(0, 500);
    const key = `${kind}|${text.slice(0, 120)}`;
    if (seen.has(key)) return;
    seen.add(key);
    sent += 1;
    const body = JSON.stringify({ kind, message: text, path: safePath(), template });
    if (body.length > 2000) return;
    nativeFetch(endpoint, {
      method: 'POST',
      body,
      headers: { 'content-type': 'application/json' },
      keepalive: true,
      mode: 'cors',
      credentials: 'omit',
    }).catch(() => {});
  };

  addEventListener('error', (event) => {
    if (event.target && event.target !== window) return; // imatges o fitxers que no carreguen: no és un error de codi
    const message = event.message || '';
    if (!message || message === 'Script error.') return; // scripts d'altres dominis sense detall
    const file = event.filename ? event.filename.split('?')[0].split('/').pop() : '';
    send('js_error', file ? `${message} @${file}:${event.lineno || 0}` : message);
  });

  addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    send('unhandled_rejection', reason && (reason.message || String(reason)));
  });

  const isCartAdd = (url) => /\/cart\/add(?:\.js)?(?:[?#]|$)/.test(url);
  window.fetch = function mpBalisaFetch(input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const result = nativeFetch(input, init);
    if (isCartAdd(url)) {
      result.then(
        (response) => {
          // 422 = sense estoc o quantitat no disponible: resposta normal de la botiga, no una avaria.
          if (!response.ok && response.status !== 422) send('cart_add_failed', `HTTP ${response.status}`);
        },
        (error) => send('cart_add_failed', `network ${(error && error.name) || 'error'}`),
      );
    }
    return result;
  };
})();
